export default __webpack_public_path__ + "static/26-3dfc163d3e76b235bcb8d5f73f5ac9d4.jpg";